/* DON'T EDIT THIS FILE: edit original and run build again */ export const investorUserCompanyTypeId = "investor";
export const sgrUserCompanyTypeId = "sgr";
export const bankUserCompanyTypeId = "bank";
export const alycUserCompanyTypeId = "alyc";
export const valueChainUserCompanyTypeId = "valueChain";
export const chamberUserCompanyTypeId = "chamber";
